import { mutationStore } from "@/libs/network/services/OfflineAsyncMutationStore";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "./ui/drawer";
import { IconRoute } from "@tabler/icons-react";
import {
  openAppleMaps,
  openGoogleMaps,
} from "@/libs/tours-detail/utils/navigation";
import { Address, VehicleType } from "@/libs/api/types";
import { Capacitor } from "@capacitor/core";

interface NavigationSelectProps {
  address: string;
  vehicle: VehicleType;
}

export function NavigationSelect({ address, vehicle }: NavigationSelectProps) {
  const { t } = useTranslation();

  if (Capacitor.getPlatform() === "android") {
    return (
      <Button
        variant="outline"
        className="h-9 w-full mt-6 rounded-full hover:bg-slate-200"
        onClick={() => openGoogleMaps(address, vehicle)}
      >
        <IconRoute className="mr-1 h-4 w-4" /> {t("common.navigate")}
      </Button>
    );
  }

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button
          variant="outline"
          className="h-9 w-full mt-6 rounded-full hover:bg-slate-200"
        >
          <IconRoute className="mr-1 h-4 w-4" /> {t("common.navigate")}
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader className="pb-12">
          <DrawerTitle>{t("common.navigate")}</DrawerTitle>
          <DrawerDescription hidden />
        </DrawerHeader>

        <div className="space-y-2 p-4 pb-safe z-50">
          <Button
            variant="outline"
            className="w-full"
            onClick={() => openGoogleMaps(address, vehicle)}
          >
            Google Maps
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => openAppleMaps(address, vehicle)}
          >
            Apple Maps
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
